// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CascadingSelectAnyController from "./cascading_select_any_controller"
application.register("cascading-select-any", CascadingSelectAnyController)

import CascadingSelectController from "./cascading_select_controller"
application.register("cascading-select", CascadingSelectController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ToggleElementController from "./toggle_element_controller"
application.register("toggle-element", ToggleElementController)
